// src/pages/Members/MembersTable/MembersTable.tsx
import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Typography,
  Button,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import PendingIcon from "@mui/icons-material/Pending";
import styles from "../MembersPageStyles";
import { calculateAge } from "../MemberPageUitls";
import { getAvatarByGender } from "../../../utils/avatarUtils";

interface Member {
  codename: string;
  gender: string;
  dob: string;
  member_status: string;
}

const getStatusIcon = (status: string) => {
  switch (status) {
    case "approved":
      return <CheckCircleIcon sx={{ color: "green" }} />;
    case "denied":
      return <CancelIcon sx={{ color: "red" }} />;
    case "pending":
      return <PendingIcon sx={{ color: "orange" }} />;
    default:
      return null;
  }
};

interface MembersTableProps {
  members: Member[];
  onMemberClick: (member: Member) => void;
}

const MembersTable: React.FC<MembersTableProps> = ({
  members,
  onMemberClick,
}) => {
  const { MembersHeaderCell, NameAvatarBox, NameAgeBox, NameType, AgeType } =
    styles;

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell
              sx={MembersHeaderCell}
              style={{ borderRight: "1px solid #D9D5EC" }}
            >
              Participant Code
            </TableCell>
            <TableCell
              sx={MembersHeaderCell}
              style={{ borderRight: "1px solid #D9D5EC" }}
            >
              Benefits
            </TableCell>
            <TableCell
              sx={MembersHeaderCell}
              style={{ borderRight: "1px solid #D9D5EC" }}
            >
              Status
            </TableCell>
            <TableCell sx={MembersHeaderCell}>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {members.map((member, index) => (
            <TableRow
              key={index}
              sx={{
                backgroundColor: index % 2 === 0 ? "white" : "#F4F2FF",
                cursor: "pointer",
              }}
              onClick={() => onMemberClick(member)}
            >
              <TableCell sx={{ borderRight: "1px solid #D9D5EC" }}>
                <Box sx={NameAvatarBox}>
                  <Box
                    component="img"
                    src={getAvatarByGender(member.gender)}
                    alt={`${member.gender} avatar`}
                    sx={{
                      width: "75.842px",
                      height: "74.598px",
                      borderRadius: "25.934px",
                    }}
                  />
                  <Box sx={NameAgeBox}>
                    <Typography sx={NameType} variant="body1">
                      {member.codename}
                    </Typography>
                    <Typography variant="body2" sx={AgeType}>
                      {member.gender} {calculateAge(member.dob)}
                    </Typography>
                  </Box>
                </Box>
              </TableCell>
              <TableCell sx={{ borderRight: "1px solid #D9D5EC" }}>
                <Typography>No benefits assigned</Typography>
              </TableCell>
              <TableCell sx={{ borderRight: "1px solid #D9D5EC" }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  {getStatusIcon(member.member_status)}
                  <Typography>{member.member_status}</Typography>
                </Box>
              </TableCell>
              <TableCell>
                <Button
                  variant="contained"
                  onClick={(e) => {
                    e.stopPropagation();
                    console.log("Action clicked for", member.codename);
                  }}
                  sx={{
                    bgcolor: "#5958e1",
                    "&:hover": { bgcolor: "#4a49b3" },
                  }}
                >
                  Action
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default MembersTable;
